import { Grid } from '@mui/material';

import ComponentGuard from '../../../../components/ComponentGuard';
import { PERMISSIONS } from '../../../../config/permissions';
import { ASSETICOM_ROLES } from '../../../../config/roles';
import BulkUploader from '../components/BulkUploader';

const AddBulk = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ComponentGuard
          auth={{
            atLeast: ASSETICOM_ROLES.ASSETICOM_ADMIN,
            allowedUids: [PERMISSIONS.BULK_UPLOADING],
          }}
        >
          <BulkUploader />
        </ComponentGuard>
      </Grid>
    </Grid>
  );
};

export default AddBulk;
